import { isGeologie, isPiecesla } from '../retailer';

export default function showRecommendations() {
  const hide = isGeologie() || isPiecesla();
  return !hide;
}
